import { BaseUser } from "./baseUser";

export class CallMessage {
  public id: number;
  public message: string;
  public date: Date;
  public owner: BaseUser;     //Если null, то сообщение отправлено Диспетчером
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/callMessage.ts